// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';
import { xhrFetch } from './xhrFetch';

const SUPABASE_URL = "https://alcupjodcjyjfixymqbh.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFsY3Vwam9kY2p5amZpeHltcWJoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzkwMjA3MzYsImV4cCI6MjA5NDU5NjczNn0.riSfGUM4EHG5o6pYvXLURi4do7VUfc0thUiqYmDlo-M";

// In Lovable's preview environment, window.fetch is wrapped by lovable.js
// and breaks Supabase auth POSTs. Detect preview hosts and route Supabase
// requests through an XHR-based fetch so they bypass the proxy.
// In production builds we use the native fetch.
const isPreviewHost =
  typeof window !== "undefined" &&
  /\.lovableproject\.com$|\.lovable\.app$/.test(window.location.hostname);

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  },
  global: isPreviewHost ? { fetch: xhrFetch } : undefined,
});